import { IGroupTabModel } from "@/Administration/Models/UI/Group/IGroupTabModel";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { EmployeeGroupUIModel } from "@/Common/Models/UI/Employee/EmployeeGroupUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IGroupDetailsSettingEditComponentProps {
    model: IGroupTabModel;
}

class GroupDetailsSettingEditComponentState {
    public editedGroup: EmployeeGroupUIModel;
    public clinicians: Person[];
    public selectClinician: Person;
    public tempListClinician: Person[];
    public isLinkValid: boolean;
    public HideInactiveUsers: boolean;
}

class GroupDetailsSettingEditComponent extends React.Component<IGroupDetailsSettingEditComponentProps, GroupDetailsSettingEditComponentState> {
    public constructor(props: Readonly<IGroupDetailsSettingEditComponentProps>) {
        super(props);
        const editedGroup = this.props.model.get("EditedGroup");

        this.state = {
            editedGroup: editedGroup,
            tempListClinician: editedGroup.getAllClinicianByContactFacetId(),
            clinicians: cacheStore.GetClinicians(true),
            isLinkValid: editedGroup.linkValid,
            HideInactiveUsers: true,
            selectClinician: null
        };
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(prevProps: IGroupDetailsSettingEditComponentProps): void {
        let currentGroup = this.props.model.get("EditedGroup");
        let prevGroup = prevProps.model.get("EditedGroup");
        if (currentGroup != prevGroup) {
            this.mutateState(s => {
                s.editedGroup = currentGroup;
                s.tempListClinician = s.editedGroup.getAllClinicianByContactFacetId();
                s.clinicians = this.state.clinicians;
            });
        }
    }

    public render(): JSX.Element {
        return (
            <div>
                <div style={{ margin: "10px", marginTop: "20px" }}>
                    <h3 className="thin-font">{this.state.editedGroup.Model.Name}</h3>
                </div>

                <div className="user-component">
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("MemberLabel")}</h3>
                        </div>
                    </div>
                    <div className="psingle-column practice centered" style={{ "marginBottom": "5px" }}>
                        <div className="tb">
                            {this.renderMembers()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderMembers(): JSX.Element {
        let cliniciansFiltered;

        if (this.state.HideInactiveUsers) {
            cliniciansFiltered = this.state.clinicians
                .filter(x => !x.EmployeeModel.IsInactive)
                .map(x => new SearchableItemModelT<Person>(x.NameWithPrefix, x.ContactFacetId, x))
                .toImmutable();
        }
        else {
            cliniciansFiltered = this.state.clinicians
                .map(x => new SearchableItemModelT<Person>(x.NameWithPrefix, x.ContactFacetId, x))
                .toImmutable();
        }

        return (
            <div className="tbc">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1"><label>{cacheStore.GetString("MemberLabel")}</label></td>
                                <td className="c2">
                                    <TextboxControl
                                        id="txtEmployee_GroupEdit_Add"
                                        style={{ marginBottom: "5px" }}
                                        value=""
                                        debounceMs={200}
                                        RemoveStyle={true}
                                        className="form-control"
                                        autoCompleteItems={cliniciansFiltered}
                                        onAutoCompleteSelectCallBack={(id: string, model: Person) => this.onEmployeeInfoSelect(model, id)}
                                        onClickRestrictedSearch={true}
                                        placeholder=""
                                    />

                                </td>
                                <td className="c2">
                                    <CheckboxControl
                                        id="hideInactiveUsers"
                                        checked={this.state.HideInactiveUsers}
                                        label={cacheStore.GetString("HideInactiveUsersLabel")}
                                        onChange={() => this.mutateState(s => { s.HideInactiveUsers = !this.state.HideInactiveUsers; })}
                                    />
                                </td>
                            </tr>
                            {this.state.tempListClinician.filter(p => !!p).map((clinician: Person, index: number) => (
                                <tr key={"group_" + index}>
                                    <td className="c1"><label /></td>
                                    <td className="c2">
                                        <div className="flex-container" style={{ justifyContent: "space-between" }}>
                                            <div> {clinician.NameWithPrefix}</div>
                                            <div className="red-text bold pointer" onClick={() => this.removeUser(clinician)}>X</div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private removeUser(user: Person): void {
        this.mutateState(s => {
            s.editedGroup = this.state.editedGroup;
            let newUsers = s.editedGroup.Model.EmployeeContactFacetIds.filter(x => x.toString() != user.ContactFacetId.toString());
            s.editedGroup.Model.EmployeeContactFacetIds = newUsers;
            s.tempListClinician = s.editedGroup.getAllClinicianByContactFacetId();
        });
    }

    private mutateState(mutation: (s: GroupDetailsSettingEditComponentState) => void): void {
        var s = new GroupDetailsSettingEditComponentState();
        mutation(s);
        this.setState(s, () => {
            let group = this.props.model.get("EditedGroup");
            sessionStore.dispatch(LocalOperations.AdministrationGroup.MutateGroupModel, { EditedGroup: group });
        });
    }

    private onEmployeeInfoSelect(model: Person, id: string): void {
        if (id != null)
            this.mutateState(s => {
                s.selectClinician = model;
                s.editedGroup = this.state.editedGroup;
                if (s.editedGroup.Model.EmployeeContactFacetIds.indexOf(model.ContactFacetId) == -1)
                    s.editedGroup.Model.EmployeeContactFacetIds.push(model.ContactFacetId);
                s.tempListClinician = s.editedGroup.getAllClinicianByContactFacetId();
                s.clinicians = cacheStore.GetClinicians(true);
            });
    }
}

export { GroupDetailsSettingEditComponent };
